import React, { useState } from 'react';
import { Calendar, Plus, X } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
// Örnek Etkinlikler
const initialEvents = [{
  id: 1,
  title: 'Genel Veli Toplantısı',
  date: '25 Ekim 2023',
  location: 'Konferans Salonu',
  description: 'Tüm velilerin katılımı beklenmektedir. Toplantıda öğrencilerin akademik durumları ve okul genelindeki gelişmeler değerlendirilecektir.'
}, {
  id: 2,
  title: '8. Sınıflar Motivasyon Semineri',
  date: '28 Ekim 2023',
  location: 'Online',
  description: 'LGS sınavına hazırlanan 8. sınıf öğrencileri için uzman psikologlar eşliğinde motivasyon semineri düzenlenecektir.'
}, {
  id: 3,
  title: 'Öğretmenler Kurulu Toplantısı',
  date: '1 Kasım 2023',
  location: 'Öğretmenler Odası',
  description: 'Dönem içi değerlendirme ve sınav takviminin planlanması için tüm öğretmenlerin katılımı zorunludur.'
}, {
  id: 4,
  title: 'Bilim Fuarı',
  date: '15 Kasım 2023',
  location: 'Okul Bahçesi',
  description: 'Öğrencilerimizin hazırladığı bilim projeleri sergilenecektir. Tüm velilerimiz davetlidir.'
}, {
  id: 5,
  title: 'Öğrenci Meclisi Seçimleri',
  date: '20 Kasım 2023',
  location: 'Tüm Sınıflar',
  description: 'Öğrenci temsilcileri ve okul meclisi başkanı seçimleri yapılacaktır.'
}];
// Yeni Etkinlik Ekleme Modalı
const YeniEtkinlikModal = ({
  onClose,
  onSave
}) => {
  const [formData, setFormData] = useState({
    title: '',
    date: '',
    location: '',
    description: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };
  return <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-id="element-1497">
      <AuroraFloatingCard className="w-full max-w-lg" data-id="element-1498">
        <div className="relative" data-id="element-1499">
          <h3 className="text-lg font-bold mb-4" data-id="element-1500">Yeni Etkinlik Ekle</h3>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1501">
            <div data-id="element-1502">
              <label className="block text-sm font-medium mb-1" data-id="element-1503">
                Etkinlik Başlığı
              </label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} className="w-full bg-white/5 text-white rounded-lg p-2 border border-amber-500/30 focus:border-amber-500 focus:ring-amber-500/50" required data-id="element-1504" />
            </div>
            <div data-id="element-1505">
              <label className="block text-sm font-medium mb-1" data-id="element-1506">Tarih</label>
              <input type="text" name="date" value={formData.date} onChange={handleChange} placeholder="Örn: 25 Ekim 2023" className="w-full bg-white/5 text-white rounded-lg p-2 border border-amber-500/30 focus:border-amber-500 focus:ring-amber-500/50" required data-id="element-1507" />
            </div>
            <div data-id="element-1508">
              <label className="block text-sm font-medium mb-1" data-id="element-1509">Konum</label>
              <input type="text" name="location" value={formData.location} onChange={handleChange} className="w-full bg-white/5 text-white rounded-lg p-2 border border-amber-500/30 focus:border-amber-500 focus:ring-amber-500/50" required data-id="element-1510" />
            </div>
            <div data-id="element-1511">
              <label className="block text-sm font-medium mb-1" data-id="element-1512">Açıklama</label>
              <textarea name="description" value={formData.description} onChange={handleChange} className="w-full h-24 bg-white/5 text-white rounded-lg p-2 border border-amber-500/30 focus:border-amber-500 focus:ring-amber-500/50" required data-id="element-1513" />
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-1514">
              <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10" data-id="element-1515">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 rounded-lg bg-gradient-to-r from-amber-600 to-orange-600 hover:opacity-90" data-id="element-1516">
                Kaydet
              </button>
            </div>
          </form>
          <button onClick={onClose} className="absolute top-0 right-0 text-gray-500 hover:text-white" data-id="element-1517">
            <X className="w-5 h-5" data-id="element-1518" />
          </button>
        </div>
      </AuroraFloatingCard>
    </div>;
};
export function YoneticiEtkinlikler() {
  const [events, setEvents] = useState(initialEvents);
  const [showModal, setShowModal] = useState(false);
  const handleSaveEvent = eventData => {
    const newEvent = {
      id: events.length + 1,
      ...eventData
    };
    setEvents([...events, newEvent]);
  };
  return <div className="relative space-y-8" data-id="element-1519">
      {showModal && <YeniEtkinlikModal onClose={() => setShowModal(false)} onSave={handleSaveEvent} data-id="element-1520" />}
      {/* Başlık */}
      <div className="flex justify-between items-center" data-id="element-1521">
        <div data-id="element-1522">
          <h1 className="text-3xl font-bold" data-id="element-1523">Etkinlik Yönetimi</h1>
          <p className="text-gray-400 mt-1" data-id="element-1524">
            Tüm etkinlikleri görüntüleyin ve yönetin
          </p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-amber-600 to-orange-600 hover:opacity-90 text-white" data-id="element-1525">
          <Plus className="w-5 h-5" data-id="element-1526" /> Yeni Etkinlik
        </button>
      </div>
      {/* Etkinlikler Listesi */}
      <div className="space-y-6" data-id="element-1527">
        {events.map(event => <AuroraFloatingCard key={event.id} data-id="element-1528">
            <div className="flex flex-col md:flex-row md:items-center gap-4" data-id="element-1529">
              <div className="flex flex-col items-center justify-center min-w-24 h-24 bg-amber-500/10 border border-amber-500/30 rounded-lg p-3 text-center" data-id="element-1530">
                <Calendar className="w-6 h-6 text-amber-400 mb-1" data-id="element-1531" />
                <span className="text-xs text-gray-400" data-id="element-1532">
                  {event.date.split(' ')[1]}
                </span>
                <span className="text-xl font-bold text-white" data-id="element-1533">
                  {event.date.split(' ')[0]}
                </span>
              </div>
              <div data-id="element-1534">
                <h3 className="text-xl font-bold text-white" data-id="element-1535">{event.title}</h3>
                <p className="text-sm text-amber-400" data-id="element-1536">{event.location}</p>
                <p className="text-gray-400 mt-2" data-id="element-1537">{event.description}</p>
              </div>
            </div>
          </AuroraFloatingCard>)}
      </div>
    </div>;
}